<style>
  .mainBackground1{
    background-image: url(../../../assets/Content/Login/main/1.jpg);background-size: cover;
  }
  .mainBackground2{
    background-image: url(../../../assets/Content/Login/main/2.jpg);background-size: cover;
  }
  .mainBackground3{
    background-image: url(../../../assets/Content/Login/main/3.jpg);background-size: cover;
  }
  .mainBackground4{
    background-image: url(../../../assets/Content/Login/main/4.jpg);background-size: cover;
  }
  .mainBackground5{
    background-image: url(../../../assets/Content/Login/main/5.jpg);background-size: cover;
  }
  .mainBackground6{
    background-image: url(../../../assets/Content/Login/main/6.jpg);background-size: cover;
  }
</style>


<section *ngIf="!MustChangePassword" class="height-100vh d-flex align-items-center page-section-ptb login"
[ngClass]="{'mainBackground1': MainBackground===1,
            'mainBackground2': MainBackground===2,
            'mainBackground3': MainBackground===3,
            'mainBackground4': MainBackground===4,
            'mainBackground5': MainBackground===5,
            'mainBackground6': MainBackground===6
          }">
  <div class="container">
    <div class="row  no-gutters vertical-align">

      <div class="col-lg-4 col-md-6 " style="background-color: rgba(255, 255, 255, 0.95);">
        <div class="login-fancy pb-40 clearfix">
          <h3 class="mb-30">Sign In</h3>
          <form (submit)="LogingFunction()">
            <div class="section-field mb-20">
              <label class="mb-10" for="name">Username* </label>
              <input id="name" class="form-control" type="text" [(ngModel)]="username" placeholder="Username"
                name="username">
            </div>
            <div class="section-field mb-20">
              <label class="mb-10" for="Password">Password* </label>
              <input id="Password" class="Password form-control" type="password" [(ngModel)]="password"
                placeholder="Password" name="password">
            </div>

            <div class="section-field mb-20" *ngIf="CapchaImage">
              <label class="mb-10" for="Password">Security Code* </label>
              <img style="height: 50px;" src="{{BaserUrlImage}}file/capcha/{{CapchaImage}}" />
              <input id="CapchaCode" class="form-control" type="text" [(ngModel)]="CapchaCode"
                placeholder="Security Code"  name="CapchaCode">
            </div>

            <button type="submit" *ngIf="!LoadingLogin" class="button" style="color: white;">
              <span>Sign In</span>
              <i class="fa fa-check"></i>
            </button>
            <button type="button" (click)="RestCapcha()" *ngIf="!LoadingLogin && CapchaImage" class="button" style="color: white;
            background: #2d0aed;
            border: 2px #2d0aed solid;
            margin: 2px;">
              <span>Refresh Security Code</span>
              <i class="fa fa-refresh"></i>
            </button>
            <a *ngIf="LoadingLogin" class="button" style="color: white;">

              <i *ngIf="Double_loging_Check==0" class="fa fa-spin fa-refresh"></i>
              <span *ngIf="Double_loging_Check>0">Try again in {{Double_loging_Check}} seconds</span>
            </a>
            <a #search href="#"></a>
          </form>
        </div>
      </div>
    </div>
  </div>
</section>

<app-Lockscreen [Token]="Token" *ngIf="MustChangePassword"></app-Lockscreen>
